// extracted by mini-css-extract-plugin
export default {"earn-tag-text":"_3w7m299J19fO1ccg6hFBgQ=="};